// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"Cards_cardsWrapper__jHzEj"};